// ==============================
// Shared A2F robustness tuning — single source of truth.
//
// These forward-pacing constants govern how decoded PCM audio is fed to
// the NVIDIA Audio2Face bridge. They are imported by BOTH the chat path
// (`RealtimeLLMToElevenLabs.js`) and the greeting path
// (`GreetingService.js`) so the two can never silently drift apart — tune
// here once and both behave identically.
//
// Task #99: the frame-starvation / pause-on-underrun constants were
// removed. Speaker audio is never paused; lip-sync conforms to the audio
// and the mouth closes on a computed clock. Only the forward-pacer
// (which throttles ONLY the bridge-bound copy of the audio, never the
// speaker) remains.
// ==============================

// Task #21 — Client-side forward-to-A2F pacer.
//
// ElevenLabs delivers PCM_16000 audio to the browser in dense bursts
// (~20 chunks/s of audio-time per real second), but the NVIDIA A2F
// server can only process ~7 chunks/s sustained. Forwarding every
// chunk as fast as it arrives lets the bridge queue grow seconds
// deep, which starves the lip-sync driver and produces visible
// mid-utterance mouth freezes on long replies.
//
// The pacer queues inbound audio chunks and releases them on a
// wall-clock schedule so cumulative audio-ms forwarded never runs
// faster than `RATE` × wall-time. Audio playback to the speakers
// is unaffected — only the bridge-bound copy is throttled.
//
// WARMUP: the first `WARMUP_MS` of audio per turn flows through
// unthrottled so the bridge has enough material to produce the first
// lip-sync frame quickly; pacing only engages after that.
//
// Rollback: set `A2F_FORWARD_PACING_ENABLED = false` and rebuild.
// All other behavior is unchanged.
export const A2F_FORWARD_PACING_ENABLED = true;
export const A2F_FORWARD_PACING_RATE = 1.0;
export const A2F_FORWARD_PACING_WARMUP_MS = 2000;
